import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../../../../shared/components/Header/Header';
import Hero from '../../components/Hero/Hero';
import HowItWorks from '../../components/HowItWorks/HowItWorks';
import PredictionMarkets from '../../components/PredictionMarkets/PredictionMarkets';
import BettingInterface from '../../components/BettingInterface/BettingInterface';
import WhyVideoRoyale from '../../components/WhyVideoRoyale/WhyVideoRoyale';
import Architecture from '../../components/Architecture/Architecture';
import MobileSection from '../../components/MobileSection/MobileSection';
import FeatureRoadmap from '../../components/FeatureRoadmap/FeatureRoadmap';
//import CTASection from '../../components/CTASection/CTASection';
import Footer from '../../../../shared/components/Footer/Footer';

export default function LandingPage() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Extract the section ID from the pathname (e.g., "/how-it-works" -> "how-it-works")
    const sectionId = pathname.substring(1);
    if (sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        // Small delay to ensure the component is fully rendered
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    } else {
      // If no section ID, scroll to top
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [pathname]);

  return (
    <div className="landing-page">
      <Header />
      <Hero />
      <HowItWorks />
      <PredictionMarkets />
      <BettingInterface />
      <WhyVideoRoyale />
      <Architecture />
      <MobileSection />
      <FeatureRoadmap />
      {/* <CTASection /> */}
      <Footer />
    </div>
  );
}

